// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.overall-container {
  display: flex;
  margin: 20px 20px 40px 20px !important;
}
.overall-container .left-side {
  width: 50%;
  display: flex;
}
.overall-container .left-side .logo-container {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.overall-container .left-side .header-button-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: -8px;
}
.overall-container .left-side .header-button-container .logo-header {
  color: #19608f;
  font-size: 1.8em;
  font-weight: 600;
}
.overall-container .right-container {
  display: flex;
  flex-direction: column;
  width: 50%;
}

@media only screen and (max-width: 1080px) {
  .overall-container {
    transform: scale(0.9);
    margin: 20px 20px 10px 20px !important;
  }
  .overall-container .logo-container {
    margin-top: -5px;
  }
  .overall-container .logo-header {
    font-size: 24px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AdminComponent.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,sCAAA;AAUJ;AARI;EACI,UAAA;EACA,aAAA;AAUR;AARQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AAUZ;AARQ;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;AAUZ;AARY;EACI,cDjBN;ECkBM,gBAAA;EACA,gBAAA;AAUhB;AANI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAQR;;AAJA;EACI;IACI,qBAAA;IACA,sCAAA;EAON;EALM;IACI,gBAAA;EAOV;EAJM;IACI,0BAAA;EAMV;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.overall-container {\n    display: flex;\n    margin: 20px 20px 40px 20px !important;\n\n    .left-side {\n        width: 50%;\n        display: flex;\n\n        .logo-container {\n            display: flex;\n            flex-direction: column;\n            margin-right: 10px;\n        }\n        .header-button-container {\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            margin-top: -8px;\n\n            .logo-header {\n                color: $dk-blue;\n                font-size: 1.8em;\n                font-weight: 600;\n            }\n        }\n    }\n    .right-container {\n        display: flex;\n        flex-direction: column;\n        width: 50%;\n    }\n}\n\n@media only screen and (max-width: 1080px) {\n    .overall-container {\n        transform: scale(.9);\n        margin: 20px 20px 10px 20px !important;\n\n        .logo-container {\n            margin-top: -5px;\n        }\n\n        .logo-header {\n            font-size: 24px !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
